/**
 * The policy text itself, with no page or modal chrome around it.
 *
 * It lives here because it is now read from two places — the standalone `/privacy` route and the
 * consent modal on checkout — and a privacy notice that says two different things depending on
 * where the reader opened it is worse than one that is merely inconvenient to reach. Consent is
 * recorded against `consentVersion`, so the wording a buyer ticked has to be the wording the page
 * shows, from one source.
 */
export default function PrivacyPolicyBody() {
  return (
    <>
      <p style={{ color: 'var(--muted)', fontSize: 12.5, marginBottom: 16 }}>
        *ฉบับร่าง — ควรให้ทีมกฎหมายตรวจสอบก่อนเผยแพร่จริง ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA)*
      </p>

      <h3>ข้อมูลที่เก็บรวบรวม</h3>
      <p>
        ชื่อ-นามสกุล เบอร์โทรศัพท์ อีเมล (หากระบุ) ข้อมูลคำสั่งซื้อ และภาพสลิปการโอนเงิน
        เท่าที่จำเป็นต่อการยืนยันการชำระเงินและออกบัตรเข้างาน
      </p>

      <h3>วัตถุประสงค์การใช้ข้อมูล</h3>
      <p>
        เพื่อยืนยันคำสั่งซื้อ ตรวจสอบการชำระเงิน ออกบัตรเข้างาน และติดต่อกรณีมีปัญหาเกี่ยวกับคำสั่งซื้อเท่านั้น
      </p>

      <h3>ระยะเวลาการเก็บข้อมูล</h3>
      <p>
        บันทึกผลการตรวจสอบสลิปจะเก็บไม่เกิน 90 วันนับจากวันที่ตรวจสอบ แล้วระบบจะลบโดยอัตโนมัติ
        ข้อมูลคำสั่งซื้อและภาพสลิปจะเก็บเท่าที่จำเป็นสำหรับการจัดงาน การตรวจสอบ และหน้าที่ตามกฎหมาย
      </p>

      <h3>การตรวจสอบผ่านผู้ให้บริการ</h3>
      <p>
        ระบบอาจส่งภาพหรือข้อมูลจากสลิปให้ EasySlip เป็นผู้ให้บริการหลัก และ Thunder Solution
        เป็นผู้ให้บริการสำรอง เพื่ออ่านและตรวจสอบความถูกต้องของการชำระเงิน
        JamTick ไม่เก็บคำตอบแบบเต็ม (raw response) จากผู้ให้บริการเป็นค่าเริ่มต้น
        โดยเก็บเฉพาะผลที่จำเป็น เช่น ผู้ให้บริการ สถานะ ยอดเงิน และเลขอ้างอิงหรือเลขบัญชีที่ปิดบังแล้ว
      </p>
      <p>
        เพื่อให้ตรวจสอบปัญหาทางเทคนิคได้ ระบบจะบันทึกคำตอบจากผู้ให้บริการข้างต้น
        รวมถึงผู้ให้บริการส่งอีเมล (Resend) และส่ง SMS (ThaiBulkSMS)
        ในรูปแบบที่ <strong>ปิดบังข้อมูลส่วนบุคคลไว้แล้ว</strong> — ชื่อ เลขบัญชี เบอร์โทรศัพท์
        อีเมล และเลขอ้างอิงการโอน จะถูกแทนที่ก่อนบันทึกเสมอ และเก็บไม่เกิน 30 วัน
      </p>
      <p>
        ในกรณีที่ต้องตรวจสอบปัญหาที่หาสาเหตุด้วยข้อมูลที่ปิดบังแล้วไม่ได้
        ผู้ดูแลระบบอาจเปิดการบันทึกคำตอบแบบเต็มเป็นการชั่วคราว ซึ่งจะ<strong>สิ้นสุดอัตโนมัติภายใน 48 ชั่วโมง</strong>
        และข้อมูลที่บันทึกในช่วงนั้นจะถูกลบเมื่อครบกำหนดเดียวกัน
        การเปิดใช้งานและการเปิดดูข้อมูลทุกครั้งจะถูกบันทึกไว้ในบันทึกการใช้งานของระบบ
      </p>

      <h3>สิทธิของเจ้าของข้อมูล</h3>
      <p>
        ท่านมีสิทธิขอเข้าถึง แก้ไข หรือขอให้ลบข้อมูลส่วนบุคคลของท่านได้ โดยติดต่อทีมงานผ่านอีเมลที่แจ้งไว้ในหน้าหลัก
      </p>
    </>
  );
}
